<template>

  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">

      <vs-card style="border-radius: 10px;">
        <div slot="header">
          <h3 class="card-title mb-0">Búsqueda de empresa</h3>
        </div>
        <vs-row>
          <vs-col vs-lg="6" vs-xs="6" vs-sm="6">
            <CompanySelector v-model="company"/>
          </vs-col>
        </vs-row>
      </vs-card>
      <vs-card style="border-radius: 10px;">

        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="passback" true-value="Y" false-value="N">
                Omitir antipassback
              </b-checkbox>
            </b-field>
          </vs-col>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field label="Liquidación mensual postpago">
              <treeselect
                  placeholder="Seleccione una liquidación"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :options="monthlyLiquidations"
                  v-model="monthlyLiquidation"
                  name="monthlyLiquidation"

              />
            </b-field>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="subSlotControl" true-value="Y" false-value="N">
                Control sub-lotes
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="fine" true-value="Y" false-value="N">
                Omitir multa
              </b-checkbox>
            </b-field>

          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="allowEntry" true-value="Y" false-value="N">
                Permitir ingreso fuera de horario
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="allowSlot" true-value="Y" false-value="N">
                Permitir ingreso lote lleno con cobro
              </b-checkbox>
            </b-field>
          </vs-col>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field label="Liquidación Lote Lleno" v-if="allowSlot == 'Y'">
              <treeselect
                  placeholder="Seleccione una liquidación"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :options="slotLiquidations"
                  v-model="slotLiquidation"
                  name="slotLiquidation"
                  :clearable="true"
              />
            </b-field>

          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="typeVehicle" true-value="Y" false-value="N">
                Obliga tipo vehículo a la entrada
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="entry" true-value="Y" false-value="N">
                Entrada transitoria
              </b-checkbox>
            </b-field>
          </vs-col>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field label="Minutos" v-if="entry == 'Y'">
              <b-numberinput v-model="entryInput" min="1"></b-numberinput>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="payment" true-value="Y" false-value="N">
                Obligar pago
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="applyFlyPass" true-value="Y" false-value="N">
                Opera flypass
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="validateFlyPassEntry" true-value="Y" false-value="N">
                Autoriza entrada flypass con barrera
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="validateFlyPassOut" true-value="Y" false-value="N">
                Autoriza salida flypass
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="isIncomeLpr">
                Entrada LPR
              </b-checkbox>
            </b-field>
          </vs-col>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12"
                  v-if="isIncomeLpr">
            <label>Tipos de abonado</label>
            <multiselect
                v-model="selectedLprTypes"
                placeholder="Seleccione el tipo de abonado"
                label="title"
                track-by="code"
                :options="lprTypes"
                :multiple="true"
                :close-on-select="false"
                :show-no-results="false">
            </multiselect>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field>
              <b-checkbox v-model="isLprRotation" true-value="true" false-value="false">
                Lpr rotación
              </b-checkbox>
            </b-field>
          </vs-col>
          <vs-col vs-lg="3"
                  vs-xs="12"
                  vs-sm="12"
                  v-if="isLprRotation">
            <b-field label="Seleccione si aplica entrada">
              <b-checkbox v-model="entryRotation" true-value="true" false-value="false">
                LPR entrada
              </b-checkbox>
            </b-field>
          </vs-col>
          <vs-col vs-lg="3"
                  vs-xs="12"
                  vs-sm="12"
                  v-if="isLprRotation">
            <b-field label="Seleccione si aplica salida">
              <b-checkbox v-model="outRotation" true-value="true" false-value="false">
                LPR salida
              </b-checkbox>
            </b-field>
          </vs-col>
        </vs-row>
        <br>

        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field label="Tipo renovación">
              <treeselect
                  placeholder="Seleccione tipo renovación"
                  expanded
                  :options="renovationTypes"
                  v-model="renovationType"
                  name="typeUse"
              />
            </b-field>
          </vs-col>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field label="Días límite para pago *" v-if="renovationType == 'CONTRACT'">
              <b-numberinput
                  v-model="daysAllowed"
                  min="1"
                  placeholder="Número de días">
              </b-numberinput>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <b-field label="Mínimo de días *">
              <b-numberinput
                  v-model="minimunDays"
                  min="0"
                  max="15"
                  required
                  :readonly="true"
                  placeholder="Aplica periodicidad días"></b-numberinput>
            </b-field>
          </vs-col>
        </vs-row>
        <br>
        <!--  aca termina -->


        <div class="buttons button-group">
          <b-button @click="save()" type="is-info"> Guardar</b-button>
          <b-button @click="confirmAmnesty" type="is-warning"> Amnistia de Mensuales</b-button>
        </div>


      </vs-card>
    </vs-col>
  </vs-row>


</template>

<script>
import {ROUTES} from "@/global/api_routes";
import CompanySelector from "@/components/Shared/CompanySelector";
import liquidationEndpoint from "@/endpoints/billing/LiquidationEndpoint";
import incomeSettingEndpoint from "@/endpoints/income/IncomeSettingEndpoint";
import toast from "@/global/ToastConfig";
import TreeSelect from "@riophae/vue-treeselect";
import Multiselect from "vue-multiselect";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import EKind from "@/global/lasting/EKind";


export default {
  name: "IncomeSettings",
  components: {Multiselect, TreeSelect, CompanySelector},
  data: () => ({
    id: null,
    isIncomeLpr: true,
    monthlyLiquidation: null,
    monthlyLiquidations: [],
    slotLiquidation: null,
    slotLiquidations: [],
    company: null,
    entryInput: 1,
    passback: "N",
    subSlotControl: "N",
    renovationType: null,
    renovationTypes: [
      {id: "CONTRACT", label: "CONTRATO"},
      {id: "MONTH", label: "MES"}
    ],
    fine: "N",
    allowEntry: "N",
    allowSlot: "N",
    typeVehicle: "N",
    entry: "N",
    days: [],
    isLoading: false,
    daysAllowed: null,
    minimunDays: null,
    forceRender: 0,
    lprTypes: [],
    selectedLprTypes: [],
    isLprRotation: false,
    outRotation: false,
    entryRotation: false,
    lprRotation: {
      inLpr: false,
      outLpr: false
    }, payment: "Y",
    applyFlyPass: "N",
    validateFlyPassOut: "N",
    validateFlyPassEntry: "N",
  }),
  mounted() {
    unityEndpoint.getUnityListByKind(EKind.INCOME_TYPES, 'Tipos de abonado')
        .then(list => {
          list = list.map(item => ({code: item.code, title: item.title, initials: item.initials}))
          this.selectedLprTypes = list.filter(item => item.initials === 'MSL')
          this.lprTypes = list
        })
  },
  watch: {
    company() {
      if (this.company) {
        this.isLoading = true;
        this.getLiquidationList(this.company);
        this.getIncome();
        return;
      }
      this.tableData = [];
      this.company = null;
    },
    renovationType(newValue) {
      if (!newValue && newValue !== "CONTRACT") {
        this.daysAllowed = null;
      }
    },
    allowSlot(newValue) {
      if (newValue === "N") {
        this.slotLiquidation = null;
      }
    },
    isLprRotation(newValue) {
      if (newValue === "false") {
        this.isLprRotation = false;
        this.entryRotation = false;
        this.outRotation = false;
      }
      this.updateLprRotation();
    },
    entryRotation() {
      this.updateLprRotation();
    },
    outRotation() {
      this.updateLprRotation();
    }
  },
  methods: {
    updateLprRotation() {
      if (this.isLprRotation) {
        this.lprRotation.inLpr = this.entryRotation;
        this.lprRotation.outLpr = this.outRotation;
      } else {
        this.lprRotation = {
          inLpr: false,
          outLpr: false
        };
      }
    },
    save() {
      try {
        this.validateSave();
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          const send = {
            code: this.id,
            company: {
              code: this.company,
            },
            skipPenalty: this.fine,
            outTime: this.allowEntry,
            payFull: this.allowSlot,
            validateVehicleType: this.typeVehicle,
            liquidationPostpaid: {
              code: this.monthlyLiquidation,
            },
            transitory: this.entry,
            transitoryTime: this.entry === "N" ? null : this.entryInput,
            payFullLiquidation: {
              code: this.slotLiquidation,
            },
            applySubSlot: this.subSlotControl,
            antiPassBack: this.passback,
            renawalType: !this.renovationType ? null : this.renovationType,
            daysAllowed: this.renovationType === "CONTRACT" ? this.daysAllowed : null,
            minimunDays: this.minimunDays,
            lprSubscriptionType: this.selectedLprTypes,
            lprRotation: this.lprRotation,
            applyPay: this.payment,
            applyFlyPass: this.applyFlyPass,
            validateFlyPassOut: this.validateFlyPassOut,
            validateFlyPassEntry: this.validateFlyPassEntry,
          };
          if (send.code == null) {
            delete send.code;
          }
          this.isLoading = true;
          this.$http
              .post(ROUTES.DASHBOARD.INCOME.SAVE_INCOME, send)
              .then(({data}) => {
                if (data.code > 0) {
                  this.isLoading = false;
                  this.$buefy.toast.open({
                    duration: 5000,
                    message: data.message,
                    type: "is-success",
                    container: "#resolution_container",
                  });
                  this.cleanForm();
                  this.getIncome();
                  return;
                }
                this.isLoading = false;
                this.$buefy.toast.open({
                  duration: 5000,
                  message: data.message,
                  type: "is-danger",
                  container: "#resolution_container",
                });
              });
        });
      } catch (ex) {
        toast.error(ex.message);
      }
    }
    ,
    getIncome() {
      this.isLoading = true;
      incomeSettingEndpoint.findIncomeSetting(this.company)
          .then(data => {
            this.isLoading = false;
            if (data.code <= 0) {
              this.cleanForm();
              toast.info("No se encontró configuración")
              return;
            }
            this.fillData(data.info);
            const lprRotation = data.info.lprRotation;
            if (lprRotation || lprRotation.inLpr || lprRotation.outLpr) {
              this.lprRotation = true;
              this.isLprRotation = true;
              this.lprRotation = {
                inLpr: lprRotation.inLpr,
                outLpr: lprRotation.outLpr
              };
              this.outRotation = lprRotation.outLpr;
              this.entryRotation = lprRotation.inLpr;
            }
            const types = data.info.lprSubscriptionType
            if (types)
              this.selectedLprTypes = this.lprTypes.filter(item => types.filter(type => type.code === item.code).length > 0)
          });
    }
    ,
    cleanForm() {
      this.id = null;
      this.monthlyLiquidation = null;
      this.slotLiquidation = null;
      this.entryInput = 1;
      this.passback = "N";
      this.subSlotControl="N"
      this.fine = "N";
      this.allowEntry = "N";
      this.allowSlot = "N";
      this.typeVehicle = "N";
      this.entry = "N";
      this.renovationType = null;
      this.daysAllowed = null;
      this.minimunDays = null;
      this.selectedLprTypes = []
      this.isIncomeLpr = false
      this.isLoading = false;
      this.payment = "Y";
      this.applyFlyPass = "N";
      this.validateFlyPassOut = "N";
      this.validateFlyPassEntry = "N";

    }
    ,
    fillData(selected) {
      this.id = selected.code;
      this.fine = selected.skipPenalty;
      this.allowEntry = selected.outTime;
      this.allowSlot = selected.payFull;
      this.typeVehicle = selected.validateVehicleType;
      this.monthlyLiquidation = selected.liquidationPostpaid.code;
      this.entry = selected.transitory;
      this.entryInput = this.entry === "N" ? 1 : selected.transitoryTime;
      this.slotLiquidation = selected.payFullLiquidation.code;
      this.passback = selected.antiPassBack;
      this.subSlotControl =selected.applySubSlot;
      this.renovationType = selected.renawalType;
      this.daysAllowed = selected.daysAllowed;
      this.minimunDays = selected.minimunDays;
      this.isLoading = false;
      this.payment = selected.applyPay;
      this.applyFlyPass = selected.applyFlyPass;
      this.validateFlyPassOut = selected.validateFlyPassOut;
      this.validateFlyPassEntry = selected.validateFlyPassEntry;
    }
    ,
    getLiquidationList(companyId) {
      liquidationEndpoint.liquidationList(companyId)
          .then(info => {
            if (!info) {
              toast.info("No se encontraron liquidaciones");
              return;
            }
            this.monthlyLiquidations = info;
            this.forceRender++;
            this.slotLiquidations = info;
            this.forceRender++;
          });
    }
    ,
    validateSave() {
      if (this.renovationType === "CONTRACT" && !this.daysAllowed) {
        throw new Error("Debe seleccionar días límite de pago ");
      }
      if (!this.minimunDays) {
        throw new Error("Debe digitar un mínimo de días");
      }
      if (!(this.minimunDays > 0 && this.minimunDays <= 15)) {
        throw new Error("El rango de días es 1 a 15");
      }
      if (this.daysAllowed < 0) {
        throw new Error("El limite de pago debe ser mayor e igual a cero");
      }
    },
    confirmAmnesty() {
      if (!this.company) {
        return toast.info("Seleccione la empresa");
      }
      toast.ask(this, "¿Está seguro de aplicar la amnistía")
          .then(result => {
            if (!result) {
              return;
            }
            this.isLoading = true;
            incomeSettingEndpoint.updateAntipassback(this.company)
                .then(setData => {
                  console.log("====> ", setData);
                  this.isLoading = false;
                  if (setData.code > 0) {
                    toast.ok("Se aplicó la amnistía");
                    this.cleanForm();
                    return;
                  }
                  toast.error(setData.message);
                });
          });
    }
  }
  ,
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>